/**
 * @copyright 2020, Roeland Jago Douma <roeland@famdouma.nl>
 *
 * @author Roeland Jago Douma <roeland@famdouma.nl>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */

import axios from '@nextcloud/axios'
import { generateUrl } from '@nextcloud/router'

/**
 *
 */
export async function startRegistration() {
	const url = generateUrl('/settings/api/personal/webauthn/registration')

	const resp = await axios.get(url)
	return resp.data
}

/**
 * @param {any} name -
 * @param {any} data -
 */
export async function finishRegistration(name, data) {
	const url = generateUrl('/settings/api/personal/webauthn/registration')

	const resp = await axios.post(url, { name, data })
	return resp.data
}

/**
 * @param {any} id -
 */
export async function removeRegistration(id) {
	const url = generateUrl(`/settings/api/personal/webauthn/registration/${id}`)

	await axios.delete(url)
}
